

  <!-- The Modal -->
  <div class="modal fade " id="myModal" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content font-color">
      
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Please Confirm</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
         {{PData}}
        </div>
        
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-danger" (click)="commonMethod()" data-dismiss="modal">Yes</button>
          <button type="button" class="btn btn-secondary btn-danger" data-dismiss="modal">No</button>
        </div>
      </div>
    </div>
  </div>



 